import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

/**
 * 契約情報取得
 */
export namespace ApiTaRe230 {
  // API Name
  export const name: string = 'ApiTaRe230'
  // GET parameters
  export namespace Get {
    export const path: string = '/ta/learningAssessmentSchool'

    export interface Request {
      query: {
        grade: number
        fiscalYear: number
        testMonth: number
        testCount?: number
        courseId: string
      }
    }

    // API Response
    export interface Response {
      placementTestReport: {
        memNum: string
        testNameDisp: string
        testResultList: {
          subjectCode: string
          answerId: string
          subjectScore: string
          subjectAverage: string
          subjectbias: string
          subjectGauge: {
            questionNo: number
            basicsScoreRate: string
            practicalScoreRate: string
          }[]
        }[]
      }
    }
  }

  // API本体
  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, ResponseError> {
    public get<R>(
      params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        placementTestReport: {
          memNum: '',
          testNameDisp: '',
          testResultList: [
            {
              subjectCode: '',
              answerId: '',
              subjectScore: '',
              subjectAverage: '',
              subjectbias: '',
              subjectGauge: [
                {
                  questionNo: 0,
                  basicsScoreRate: '',
                  practicalScoreRate: '',
                },
              ],
            },
          ],
        },
      }
      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(Get.path, { params: params.query }),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
